/* tslint:disable */
/* eslint-disable */
/* @relayHash 1579d1541818a2ffc1f5db9c0fb7164e */

import { ConcreteRequest } from "relay-runtime";
export type FirmDesignProfileArticleMutationInput = {
    serviceId: string;
    articles: Array<FirmDesignProfileArticleInput | null>;
    clientMutationId?: string | null;
};
export type FirmDesignProfileArticleInput = {
    photoId?: string | null;
    description?: string | null;
    url?: string | null;
    title?: string | null;
};
export type profileArticlesMutationVariables = {
    input: FirmDesignProfileArticleMutationInput;
};
export type profileArticlesMutationResponse = {
    readonly firmDesignProfileArticleMutation: {
        readonly tradeFirm: {
            readonly publicProfile: {
                readonly articles: ReadonlyArray<{
                    readonly photo: {
                        readonly path: string | null;
                        readonly serviceId: string | null;
                    } | null;
                    readonly title: string | null;
                    readonly description: string | null;
                    readonly webLink: {
                        readonly url: string | null;
                    } | null;
                } | null> | null;
            } | null;
        } | null;
    } | null;
};
export type profileArticlesMutation = {
    readonly response: profileArticlesMutationResponse;
    readonly variables: profileArticlesMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "FirmDesignProfileArticleMutationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "path",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "webLink",
  "storageKey": null,
  "args": null,
  "concreteType": "WebLink",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "url",
      "args": null,
      "storageKey": null
    }
  ]
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "profileArticlesMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "firmDesignProfileArticleMutation",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "FirmDesignProfileArticleMutationPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tradeFirm",
            "storageKey": null,
            "args": null,
            "concreteType": "TradeFirmType",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "publicProfile",
                "storageKey": null,
                "args": null,
                "concreteType": "TradeFirmPublicProfileType",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "articles",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DesignFirmArticleType",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "photo",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Photo",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/)
                        ]
                      },
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "profileArticlesMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "firmDesignProfileArticleMutation",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "FirmDesignProfileArticleMutationPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tradeFirm",
            "storageKey": null,
            "args": null,
            "concreteType": "TradeFirmType",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "publicProfile",
                "storageKey": null,
                "args": null,
                "concreteType": "TradeFirmPublicProfileType",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "articles",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DesignFirmArticleType",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "photo",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Photo",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v7/*: any*/)
                        ]
                      },
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ]
                  }
                ]
              },
              (v7/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "profileArticlesMutation",
    "id": "app-buyer-trade/267.0.0-2020-06-02T16:23:38.038Z/profileArticlesMutation",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '091e92845465523c8493e4b964db5b4b';
export default node;
